<ng-content select="[slot='picture']" />
<ng-content select="[slot='title']" />
<ng-content select="[slot='content']" />
